import { memo, ReactElement } from 'react';
import { AutocompleteInput, AutocompleteInputProps, ReferenceInput, ReferenceInputProps, SelectInput, SelectInputProps, useResourceContext } from 'react-admin';
import Option from '../GeneratedModels/Option';
import ReferenceQuickCreateInput from '../react-admin/ReferenceQuickCreateInput';

/**
 * Generated by Db2Ts @ 2023-06-12 15:11:1148
 */

interface OptionSelectInputProps extends Omit<SelectInputProps, "optionText"> {
  optionText: 'id' | 'is_public' | 'tree_node_parent_id' | 'tree_node_parent_order' | 'option_type' | 'name_en' | 'name_tc' | 'name_sc' | 'desc_en' | 'desc_tc' | 'desc_sc' | 'created' | 'createdBy' | 'updated' | 'updatedBy' | ((data: Option) => string),
}

interface OptionAutocompleteInputProps extends Omit<AutocompleteInputProps, "optionText"> {
  optionText: keyof Option | ((data: Option) => string),
  filterProps: Array<keyof Option>,
}

interface OptionReferenceInputProps extends Omit<ReferenceInputProps, 'source' | 'reference' | 'children'> {
  source?: string,
  reference?: string,
  selectInputProps?: OptionSelectInputProps,
  autocompleteInputProps?: OptionAutocompleteInputProps,
  filter?: Partial<Option>,
  useAutocomplete?: boolean,

  quickCreate?: {
    fields?: ReactElement,
    formElements?: ReactElement,
  }
}

function OptionReferenceInput({ label, source, reference, selectInputProps, useAutocomplete, autocompleteInputProps, quickCreate, validate, name, ...rest }: OptionReferenceInputProps) {
  const resource = useResourceContext();
  label = label ?? `resources.${resource}.fields.${source}`
  return (
    quickCreate
      ? <ReferenceQuickCreateInput selectInputProps={selectInputProps as any} {...rest} {...quickCreate} source={source ?? "option_id"} reference={reference ?? "option"} />
      : <ReferenceInput {...rest} source={source ?? "option_id"} reference={reference ?? "option"} label={label}>
        {useAutocomplete && autocompleteInputProps
          ? <AutocompleteInput filterToQuery={q => ({ __mode: 'filterToQuery', ...(Object.fromEntries(autocompleteInputProps.filterProps.map(x => [x, q]))) })} {...autocompleteInputProps}/>
          : <SelectInput disabled={rest.disabled} {...selectInputProps} fullWidth validate={validate} name={name} label={label} />
        }
      </ReferenceInput>
  )
}

OptionReferenceInput.defaultProps = {
  addLabel: true,
  fullWidth: true,
  // label: "Option",
  source: "option_id",
  reference: "option",
  perPage: 3000,
  selectInputProps: {
    optionText: 'name_tc',
  },
  autocompleteInputProps: {
    optionText: 'name_tc',
    filterProps: ['tree_node_parent_id'],
  }
};

export default memo(OptionReferenceInput);
